"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaElementSupervisor = void 0;
const adapter_1 = require("../../api/adapter");
const play_logs_1 = require("../utils/debug/play-logs");
const event_emitter_1 = require("../utils/events/event-emitter");
const core_1 = require("./core");
const elementsSupervisors = new WeakMap();
class MediaElementSupervisor extends event_emitter_1.ObservableEventEmitter {
    constructor(element) {
        super();
        this.element = element;
        this.activePlayer = null;
        this.debugSuspendTimeupdate = false;
        element.setAttribute("playsinline", "true");
        element.setAttribute("webkit-playsinline", "true");
        this.startListenEvent("play", "handleElPlay");
        this.startListenEvent("pause", "handleElPause");
        this.startListenEvent("volumechange", "handleElVolumeChange");
        this.startListenEvent("error", "handleElError");
        this.startListenEvent("progress", "handleElProgress");
        core_1.timeupdateWrapper.wrap(element, this.createEventHandler("handleElTimeupdate"));
        core_1.timeupdateWrapper.wrap(element, this.createEventHandler("handleElTimeupdate"));
        this.element.addEventListener("loadeddata", () => {
            this.emit("loadeddata");
        });
    }
    get muted() {
        return this.element.muted;
    }
    set muted(val) {
        this.element.muted = val;
    }
    get paused() {
        return this.element.paused;
    }
    get volume() {
        return this.element.volume;
    }
    set volume(val) {
        this.element.volume = val;
    }
    get error() {
        return this.element.error;
    }
    get autoplay() {
        return this.element.autoplay;
    }
    set autoplay(val) {
        this.element.autoplay = val;
    }
    get buffered() {
        return this.element.buffered;
    }
    get ended() {
        return this.element.ended;
    }
    get readyState() {
        return this.element.readyState;
    }
    get currentTime() {
        return this.element.currentTime;
    }
    set currentTime(val) {
        this.element.currentTime = val;
    }
    get playbackRate() {
        return this.element.playbackRate;
    }
    set playbackRate(val) {
        this.element.playbackRate = val;
    }
    get sourceKind() {
        const currentLocation = adapter_1.device.isImplements(adapter_1.Feature.URL_LOCATION) ? adapter_1.device.location : "";
        if (this.element.srcObject != null) {
            return "srcObject";
        }
        if (this.element.src != null && this.element.src !== "" && this.element.src !== currentLocation) {
            return "src";
        }
        return null;
    }
    get srcObject() {
        return this.element.srcObject;
    }
    static getSupervisor(element) {
        if (!elementsSupervisors.has(element)) {
            elementsSupervisors.set(element, new MediaElementSupervisor(element));
        }
        return elementsSupervisors.get(element);
    }
    attachToPlayer(player) {
        this.element.src = "";
        this.element.srcObject = null;
        this.activePlayer = player;
        return this;
    }
    isVideoPlaying() {
        return this.element.currentTime > 0 && !this.element.paused && !this.element.ended && this.element.readyState > 2;
    }
    setPoster(val) {
        this.element.setAttribute("poster", val);
    }
    hasPoster() {
        return this.element.getAttribute("poster") != null;
    }
    createScreenshot() {
        try {
            if (adapter_1.device.isImplements(adapter_1.Feature.CREATE_SCREENSHOT)) {
                return adapter_1.device.createScreenshot(this.element);
            }
            return null;
        }
        catch (err) {
            return null;
        }
    }
    pause() {
        this.element.pause();
    }
    updateSrc(val) {
        this.element.src = val;
        this.element.srcObject = null;
    }
    updateSrcObject(val) {
        this.element.src = "";
        this.element.srcObject = val;
    }
    dumpVideoElement() {
        return (0, play_logs_1.dumpVideoElement)(this.element);
    }
    isSourceSet() {
        const currentLocation = adapter_1.device.isImplements(adapter_1.Feature.URL_LOCATION) ? adapter_1.device.location : "";
        return ((this.element.src != null && this.element.src !== "" && this.element.src !== currentLocation) ||
            this.element.srcObject != null);
    }
    play() {
        return this.element.play();
    }
    createEventHandler(handlerName) {
        return () => {
            var _a, _b;
            if (this.activePlayer == null || this.activePlayer.isDisposed) {
                return;
            }
            if (handlerName === "handleElTimeupdate" && this.debugSuspendTimeupdate) {
                return;
            }
            (_b = (_a = this.activePlayer) === null || _a === void 0 ? void 0 : _a[handlerName]) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
    }
    startListenEvent(event, handlerName) {
        const handler = this.createEventHandler(handlerName);
        this.element.addEventListener(event, handler);
        this.addInnerDisposer(this.stopListenEvent.bind(this, event, handler));
    }
    stopListenEvent(event, handler) {
        this.element.removeEventListener(event, handler);
    }
}
exports.MediaElementSupervisor = MediaElementSupervisor;
//
// export type MediaElementProxyHandlerEvents = {
//   getter: { property: string, value: any };
//   setter: { property: string, value: any };
//   callStarted: { method: string; args: any[] };
//   callEnded: { method: string; args: any[]; result: any };
//   callResolved: { method: string; args: any[]; result: any };
// };
//
// class MediaElementProxyHandler extends ObservableEventEmitter<MediaElementProxyHandlerEvents> implements ProxyHandler<VideoElement> {
//   denyListProperties = new Set<string>(["getAttribute", "setAttribute", "addEventListener", "removeEventListener"]);
//
//   constructor(private debug = false) {
//     super();
//   }
//
//   get(target: VideoElement, p: string | symbol, receiver: any): any {
//     if (!this.debug) {
//       return Reflect.get(target, p);
//     }
//
//     const value = Reflect.get(target, p);
//     if (typeof value === 'function') {
//       return (...args: any[]) => {
//         if (!this.denyListProperties.has(String(p))) {
//           this.emit("callStarted", { method: String(p), args });
//         }
//
//         const result = value.apply(target, args);
//         if (!this.denyListProperties.has(String(p))) {
//           this.emit("callEnded", { method: String(p), args, result });
//         }
//
//         if ("then" in value && typeof value.then === "function") {
//           value.then((result: any) => {
//             this.emit("callResolved", { method: String(p), args, result });
//           });
//         }
//         return result
//       }
//     } else {
//       this.emit("getter", { property: String(p), value });
//     }
//     return value;
//   }
//
//   set(target: VideoElement, p: string | symbol, newValue: any, receiver: any): boolean {
//     if (!this.debug) {
//       return Reflect.set(target, p, newValue);
//     }
//
//     this.emit("setter", { property: String(p), value: newValue });
//
//     return Reflect.set(target, p, newValue);
//   }
// }
//# sourceMappingURL=media-element-supervisor.js.map